import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { RETURN_TYPE } from 'domains/merchant-outbound-return/constants'

const propTypes = {
  returnType: PropTypes.string
}

/**
 * @param {string} returnType
 */
const MerchantOutboundReturnReturnTypeBadge = ({ returnType }) => {

  const colorMap = {
    [RETURN_TYPE.AGED]        : 'warning',
    [RETURN_TYPE.DISCONTINUE] : 'danger',
    [RETURN_TYPE.DONATED]     : 'success',
    [RETURN_TYPE.REFUNDED]    : 'primary'
  }

  const color = colorMap[returnType] || 'default'

  return <StatusBadge color={ color } label={ returnType } />
}

MerchantOutboundReturnReturnTypeBadge.propTypes = propTypes

export default MerchantOutboundReturnReturnTypeBadge
